import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';

import CustomIcon from 'components/Icons';
import ModalContainer from 'components/Common/ModalContainer';

import { ROUTING } from 'config';
import styles from './styles.module.less';

const ConfirmEmailModal = ({
  isOpen,
  onModalCancel,
  title,
  description,
  showHelp,
}) => (
  <ModalContainer
    className={styles.modalReset}
    isOpen={isOpen}
    onCancel={onModalCancel}
    title=" "
  >
    <div className={styles.modalResetContainer}>
      <div className={styles.modalResetCheckContainer}>
        <CustomIcon type="check" />
      </div>
      <Title level={2}>{title}</Title>
      <Text className={styles.modalResetText}>{description}</Text>
      {showHelp && (
        <Text className={styles.modalResetSubText}>
          If the email does not arrive,
          <br /> please contact your&nbsp;
          <Link to={ROUTING.NOT_FOUND_ERROR}>administrators</Link>.
        </Text>
      )}
    </div>
  </ModalContainer>
);

ConfirmEmailModal.defaultProps = {
  showHelp: true,
};

ConfirmEmailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalCancel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showHelp: PropTypes.bool,
};

export default ConfirmEmailModal;
